import { userStore } from '@/models/stores/index';

const useUsers = () => {
  const users = userStore.all;
  const financeManagers = userStore.financeManagers;
  const salesReps = userStore.salesReps;

  const findUserById = (id: string) => {
    return users.find((user) => user.id === id);
  };

  return {
    users,
    financeManagers,
    salesReps,
    findUserById,
  };
};

export default useUsers;
